const dotsAmount = 3;

export function truncateWithEllipsis(stringToTruncate: string, maxLength: number): string {
  const symbolsToRemoveAmount = maxLength > dotsAmount ? maxLength - dotsAmount : maxLength;
  return stringToTruncate.length < maxLength
    ? stringToTruncate
    : `${stringToTruncate.slice(0, symbolsToRemoveAmount)}...`;
}
